<template>
  <section>
    <qx-card :title="item.title" v-for="item in bankcardData" :key="item.key">
      <el-button
        @click="toAddBankcard(item.key, null, 'bindcard')"
        slot="titleRight"
        type="primary"
        plain
      >
        <i class="iconfont">&#xe6ab;</i>新增账户
      </el-button>
      <p class="noDataTip" v-show="item.tableData.data.length === 0">
        暂无绑定账户
      </p>
      <qx-detail-box :data="item" :colNum="1">
        <section class="clearPa" slot="acctName" slot-scope="prop">
          <article class="left">
            {{ prop.data.acctName }}
            <template v-if="item.key === 'public'">
              {{
                prop.data.businessLicenseNo
                  ? `（信用代码：${prop.data.businessLicenseNo}）`
                  : ''
              }}
            </template>
            <template v-if="item.key === 'private'">
              {{
                prop.data.identification
                  ? `（身份证号：${prop.data.identification}）`
                  : ''
              }}
            </template>
            <span class="primary marLeft" v-show="prop.data.isDefaultAcct === 1"
              >默认账户</span
            >
          </article>
          <article class="right">
<!--            <span-->
<!--              class="primary marLeft cur"-->
<!--              v-show="-->
<!--                prop.data.isDefaultAcct !== 1 &&-->
<!--                prop.data.pinganMoutId &&-->
<!--                prop.data.pinganNoutId-->
<!--              "-->
<!--              @click="setDefault(prop.data)"-->
<!--              >设为默认</span-->
<!--            >-->
            <span
                class="primary marLeft cur"
                 v-show="prop.data.isDefaultAcct !== 1 && prop.data.acctNo"
                @click="setDefault(prop.data)"
            >设为默认</span
            >
<!--            <span-->
<!--              class="primary marLeft cur"-->
<!--              v-if="prop.data.pinganMoutId && prop.data.pinganNoutId"-->
<!--              @click="unbind(prop.data)"-->
<!--              >解绑</span-->
<!--            >-->
            <span
              class="primary marLeft cur"
              v-if="prop.data.pinganMoutId && prop.data.pinganNoutId"
              @click="toEdit(item.key, prop.data, 'edit')"
              >修改</span
            >
            <span
              class="primary marLeft cur"
              v-if="!(prop.data.pinganMoutId && prop.data.pinganNoutId)"
              @click="toAddBankcard(item.key, prop.data, 'bindcard')"
              >绑卡</span
            >
            <!-- <span class="primary marLeft cur">修改</span> -->
          </article>
        </section>
      </qx-detail-box>
    </qx-card>
  </section>
</template>

<script>
import {
  servicerBindBankcard,
} from 'api/service';
import {
  setDefaultBankcard,
  unbindBankcard,
} from 'api';
export default {
  data () {
    return {
      bankcardData: {
        publicBankcard: {
          title: '对公账户',
          key: 'public',
          label: '银行账户',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'acctName',
                label: '账户名称',
                slot: true,
              },
              {
                prop: 'acctNo',
                label: '银行卡号',
              },
              {
                prop: 'branchName',
                label: '开户银行',
              },
            ],
            data: [],
            approveData: [],
          },
        },
        privateBankcard: {
          title: '对私账户',
          key: 'private',
          label: '银行账户',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'acctName',
                label: '账户名称',
                slot: true,
              },
              {
                prop: 'acctNo',
                label: '银行卡号',
              },
              {
                prop: 'branchName',
                label: '开户银行',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  watch: {
    '$route.query.userId': function () {
      this.getData();
    },
  },
  methods: {
    toEdit (type, item, ctrlType) {
      let bindCardParams = '';
      let id = '';
      if (item) {
        if (item.relSeq) {
          id = item.relSeq;
        }
        if (ctrlType === 'edit') {
          bindCardParams = `&ctrlType=${ctrlType}`;
        }
      }
      this.jump({
        // label: `${id ? '修改' : '新增'}账户`,
        label: '修改银行卡',
        url: `/manage/other/bankcard/edit?userId=${this.$route.query.userId}&type=${type}&id=${id || ''}${bindCardParams}`,
        full: true,
      });
    },

    toAddBankcard (type, item, ctrlType) {
      let bindCardParams = '';
      let id = '';
      if (item) {
        if (item.relSeq) {
          id = item.relSeq;
        }
        if (ctrlType === 'bindcard') {
          bindCardParams = `&acctName=${encodeURIComponent(item.acctName)}&ctrlType=${ctrlType}`;
          if (type === 'public') {
            bindCardParams += `&businessLicenseNo=${item.businessLicenseNo}`;
          }
          if (type === 'private') {
            bindCardParams += `&identification=${item.identification}`;
          }
        }
      } else {
        if (this.$route.query.idNum && this.$route.query.linkman) {
          bindCardParams += `&acctName=${encodeURIComponent(this.$route.query.linkman)}&identification=${this.$route.query.idNum}`;
        }
      }
      let userType = '';
      if (this.$route.query.worker) { // 判断是否从员工管理点击绑定银行卡过来的
        userType = 1;
      }
      if (this.$route.query.receipt) { // 判断是否从收款人管理点击绑定银行卡过来的
        userType = 5;
      }
      this.jump({
        // label: `${id ? '修改' : '新增'}账户`,
        label: '绑定银行卡',
        url: `/manage/other/bankcard/edit?userId=${this.$route.query.userId}&type=${type}${id ? `&id=${id}` : ''}${bindCardParams}&userType=${userType}`,
        full: !!id,
      });

    },
    async setDefault (item) { // 设置默认
      const confirmRes = await this.$confirm('是否确认设置该卡为默认卡', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      let userType = ''; // userType传参修改，判断从员工管理过来的userType传2，从收款人管理过来的userType传5，从公司银行账户直接过来传6
      if (this.$route.query.worker) {
        userType = 1;
      }
      if (this.$route.query.receipt) {
        userType = 5;
      }
      if (confirmRes === 'confirm') {
        const res = await setDefaultBankcard({
          relSeq: item.relSeq,
          busiId: 1315,
          busiCode: 400000,
          userType: userType,
        });
        if (!res.failed) {
          this.$message.success('设置成功');
          this.getData();
        }
      }
    },
    async unbind (item) { // 解绑
      const confirmRes = await this.$confirm('是否确认解绑该卡', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await unbindBankcard({
          relSeq: item.relSeq,
          busiId: 1315,
          logCode: 400000,
        });
        if (!res.failed) {
          this.$message.success('解绑成功');
          this.getData();
        }
      }
    },
    // 设置 开户银行 内容显示
    setBranchName (arr) {
      if (arr && arr.length) {
        for (let item of arr) {
          if (typeof item.bankProvCity === 'string') {
            item.bankProvCity = item.bankProvCity.replace(/null/g, '');
          }
          item.branchName = `${item.bankProvCity || ''} ${item.bankName || ''} ${item.branchName || ''}`;
        }
      }
    },
    async getData () {
      if (this.$route.path !== '/manage/other/bankcard') {
        return;
      }
      const res = await servicerBindBankcard({
        userId: this.$route.query.userId,
        userType: 5,
      });
      this.setBranchName(res.allPubAcct);
      this.setBranchName(res.allPriAcct);
      this.bankcardData.publicBankcard.tableData.data = res.allPubAcct;
      this.bankcardData.privateBankcard.tableData.data = res.allPriAcct;
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.noDataTip {
  text-align: center;
  font-size: 14px;
  color: #999;
  height: 16px;
  line-height: 16px;
}
.marLeft {
  margin-left: 8px;
}
</style>
